import { get, set } from 'lodash-es';
import { DEFAULT_DATE_PROPERTIES } from './firestore.helper';

/**
 * Factory for an ElasticSearch data transformer.
 */
export const defaultElasticConverter = <T>(
  dateProperties: string[] = DEFAULT_DATE_PROPERTIES
) => ({
  fromElastic: (data: any): T => {
    dateProperties.forEach((property) => setEsPropertyDate(data, property));
    return data as T;
  }
});


export const setEsPropertyDate = (data: any, key: string) => {
  const value = get(data, key, null);
  if (value && typeof value === 'object' && '_seconds' in value) {
    set(data, key, new Date(value['_seconds'] * 1000));
  }
};
